import { IFileItemBase } from '@gcl/react-core';
import { getProperty } from '@common/object.services';
import { IProjectFile } from '@file/projectFile/projectFile.models';

export const convertObjectsToFileItems: <T extends object>(items: T[], fileNameField?: string) => IFileItemBase[] = (
  items = [],
  fileNameField = 'fileName',
) => {
  return items.map((item) => {
    return convertObjectToFileItem(item, fileNameField);
  });
};

export const convertObjectToFileItem: <T extends object>(
  item: T,
  fileNameField?: string,
  fileObjectPath?: string,
) => IFileItemBase = (item, fileNameField = 'fileName', fileObjectPath = 'projectFile') => {
  const fileName: string = getProperty(item, fileNameField);
  let extension = '';
  if (typeof fileName === 'string') {
    extension = fileName.split('.').pop() ?? '';
  }
  const fileObject = getProperty(item, fileObjectPath) as typeof item;
  const newItem = (fileObject || item) as unknown as IProjectFile;
  return { fileInfo: { ...newItem }, extension };
};
